var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.232 18.184h8.555l3.18 2.739c.06.051.13.077.2.077a.3.3 0 0 0 .155-.044.416.416 0 0 0 .186-.358v-2.414h2.26c.68 0 1.232-.654 1.232-1.458V4.458C22 3.654 21.447 3 20.768 3H6.231C5.552 3 5 3.654 5 4.458v12.268c0 .804.553 1.458 1.232 1.458zM5.68 4.458c0-.36.248-.654.552-.654h14.535c.305 0 .553.294.553.654v12.268c0 .36-.248.654-.553.654h-2.6c-.187 0-.34.18-.34.402v2.025l-2.73-2.35a.307.307 0 0 0-.2-.077H6.232c-.304 0-.552-.293-.552-.654V4.458z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5h6m-6-3h6m-6-3h9",
    stroke: "currentColor",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.84377669b75cc0bdc68a75a6bcb6a598.svg";
export { ForwardRef as ReactComponent };